const CHECK_INTERVAL = 10 * 60 * 1000;

export async function checkForUpdate() {
    try {
        const response = await fetch(`/static/version.txt?v=${Date.now()}`);
        if (response.ok) {
            const latestVersion = (await response.text()).trim();
            const storedVersion = sessionStorage.getItem('app_version');
            if (!storedVersion) {
                sessionStorage.setItem('app_version', latestVersion);
                return;
            }

            if (storedVersion !== latestVersion) {
                invalidateCache(latestVersion);
            }
        }
    } catch (error) {
        console.error('Error during the App version check', error);
    }
}

function invalidateCache(latestVersion: string) {
    // eslint-disable-next-line no-alert
    if (confirm(
        'A new version of PB Admin is available. The application may not work properly with the previous version. ' +
        'Would you like to reload the page?',
    )) {
        sessionStorage.setItem('app_version', latestVersion);
        if ('caches' in window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name));
            });
        }
        location.reload();
    }
}

checkForUpdate();

setInterval(checkForUpdate, CHECK_INTERVAL);
